export enum CrudGetter {
    Pending = 'PENDING',
    PendingBasic = 'PENDING_BASIC',
    Saving = 'SAVING',
    Deleting = 'DELETING',
    Data = 'ALL_DATA',
    DataBasic = 'ALL_BASIC_DATA',
    DataStats = 'ALL_DATA_STATS',
    DataStatsBasic = 'ALL_DATA_STATS_BASIC',
    DataItem = 'ITEM_DATA',
    Detail = 'DETAIL',
    Error = 'ERROR',
    Count = "COUNT",
    Avg = "AVERAGE",
    Sum = "SUM",
    Downloading = "DOWNLOADING",
    GrouppedData = "GROUPPED_DATA"
}
